import React, {useState} from 'react';
import {useParams} from "react-router-dom";
import {useDifactoBucket} from "../../../components/utils";
import {Icon, Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import {Button} from "react-bootstrap";
import {useControlledTabs} from "../../../components/Tabs";
import {useTranslation} from "react-i18next";
import AudienceForm from '../../../components/data_products/audiences/AudienceForm';
import {useGetAudienceQuery,
  useRunAudienceMutation,
  useGetAudienceAggregationOptionsQuery,
  useGetAudiencesQuery
} from "../../../api/audienceApiSlice";
import useRunExtract from '../../../components/data_products/useRunExtract';

export default function Audience(props) {
  const { t } = useTranslation();
  const { audienceId } = useParams();
  const { data: audience, isSuccess } = useGetAudienceQuery(audienceId)
  const [run] = useRunAudienceMutation()
  const bucket = useDifactoBucket();
  const [tabProps, setActiveTab] = useControlledTabs("audience", props)
  const { data: aggregationOptions = [] } = useGetAudienceAggregationOptionsQuery()
  const { data: audiences = [] } = useGetAudiencesQuery()
  const {extractRuning, runExtract} = useRunExtract( { extractId: audienceId, extract: audience, onStart: ()=>(run(audienceId)), onStarted: ()=>(setActiveTab("extract_monitor")) })

  if( !isSuccess ) { return (<></>) }
  return (
    <>
      <Title main={t("menu.audiences")} sub={audience.name} backPath="/audiences" group={false}>
        <FormButton edit state={{activeTab: tabProps.active}}/>
        <Button key="run" onClick={runExtract} disabled={extractRuning}>
          <Icon icon={extractRuning ? 'loading' : 'play'} text={t("extract.run")} />
        </Button>
      </Title>
      <AudienceForm
        disabled
        audience={audience}
        aggregationOptions={aggregationOptions}
        audiences={audiences}
        bucket={bucket}
        tabProps={tabProps}/>
    </>
  )
}
